<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营部</el-breadcrumb-item>
      <el-breadcrumb-item>开业管理工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 统计卡片区 -->
    <div class="statistics-row">
      <el-card class="stat-card" shadow="hover">
        <div class="stat-card-header">
          <i class="el-icon-time" style="font-size: 24px; color: #e6a23c;"></i>
          <span class="stat-label">待开业</span>
        </div>
        <div class="stat-card-body">
          <span class="stat-value pending" @click="handleStatClick('IN_PROGRESS')" style="cursor:pointer">{{ statistics.pending }}</span>
        </div>
      </el-card>
      <el-card class="stat-card" shadow="hover">
        <div class="stat-card-header">
          <i class="el-icon-circle-check" style="font-size: 24px; color: #67c23a;"></i>
          <span class="stat-label">已开业</span>
        </div>
        <div class="stat-card-body">
          <span class="stat-value completed" @click="handleStatClick('COMPLETED')" style="cursor:pointer">{{ statistics.completed }}</span>
        </div>
      </el-card>
    </div>

    <!-- 列表卡片 -->
    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">开业管理列表</span>
      </div>

      <!-- 搜索条 -->
      <div class="search-bar">
        <el-form :model="queryInfo" :inline="true" size="small" label-width="80px">
          <el-form-item label="关键字">
            <el-input
              v-model="queryInfo.keyword"
              placeholder="项目名称/客户名称"
              clearable
              @clear="getList"
              @keyup.enter.native="getList"
              style="width: 200px;">
            </el-input>
          </el-form-item>
          <el-form-item label="I阶运营师" v-if="isAdminView">
            <el-select v-model="queryInfo.operatorId" placeholder="请选择" clearable filterable style="width: 150px;" @change="handleFilterChange">
              <el-option v-for="item in operatorList" :key="item._id" :label="item.name" :value="item._id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryInfo.status" placeholder="全部" clearable style="width: 120px;" @change="handleFilterChange">
              <el-option label="待开业" value="IN_PROGRESS"></el-option>
              <el-option label="已开业" value="COMPLETED"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通知日期">
            <el-date-picker
              v-model="queryInfo.dateArray"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleFilterChange"
              style="width: 240px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column label="项目名称" min-width="160">
          <template slot-scope="scope">
            <div class="text-title">{{ scope.row.projectName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="supervisorName" label="筹建督导" width="80"></el-table-column>
        <el-table-column prop="operatorName" label="I阶运营师" width="90"></el-table-column>

        <!-- 账号信息 -->
        <el-table-column label="账号信息" min-width="320">
          <template slot-scope="scope">
            <div class="text-detail">
              <el-tag size="mini" type="warning">美团</el-tag>
              <span style="margin-left:10px">{{ scope.row.accountData.meituanName || '--' }}</span>
              <span style="margin-left:10px">ID：{{ scope.row.accountData.meituanId || '--' }}</span>
            </div>
            <div class="text-detail">
              <el-tag size="mini">淘宝</el-tag>
              <span style="margin-left:10px">{{ scope.row.accountData.taobaoName || '--' }}</span>
              <span style="margin-left:10px">ID：{{ scope.row.accountData.taobaoId || '--' }}</span>
            </div>
            <div class="text-detail">
              <el-tag size="mini" type="danger">京东</el-tag>
              <span style="margin-left:10px">{{ scope.row.accountData.jdName || '--' }}</span>
              <span style="margin-left:10px">ID：{{ scope.row.accountData.jdId || '--' }}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 附加信息 -->
        <el-table-column label="附加信息" width="80">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.additionalInfo && Object.keys(scope.row.additionalInfo).length > 0" placement="right" :open-delay="0" :hide-after="0">
              <div slot="content">
                <div v-for="(value, key) in scope.row.additionalInfo" :key="key" style="line-height: 1.8;">
                  <span>{{ key }}:</span> <span v-html="getMultLine(value)"></span>
                </div>
              </div>
              <el-button type="text" size="small">查看</el-button>
            </el-tooltip>
            <span v-else style="color:#909399">--</span>
          </template>
        </el-table-column>

        <!-- 管理协议 -->
        <el-table-column label="管理协议" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.managementAgreementStatus === 'COMPLETED' ? 'success' : 'info'" size="mini">
              {{ scope.row.managementAgreementStatus === 'COMPLETED' ? '已签' : '未签' }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 通知时间 -->
        <el-table-column label="通知时间" width="110">
          <template slot-scope="scope">{{ scope.row.notifyAt | date }}</template>
        </el-table-column>

        <!-- 开业时间 -->
        <el-table-column label="开业时间" width="110">
          <template slot-scope="scope">{{ scope.row.openingAt | date }}</template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'COMPLETED' ? 'success' : 'warning'" size="small">
              {{ scope.row.status === 'COMPLETED' ? '已开业' : '待开业' }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.status !== 'IN_PROGRESS'"
              type="primary"
              size="mini"
              @click="handleSetOpenDate(scope.row)">设置开业</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <!-- 设置开业时间弹窗 -->
    <el-dialog title="设置开业时间" :visible.sync="openDateDialogVisible" width="400px" :close-on-click-modal="false">
      <el-form :model="openDateForm" label-width="100px">
        <el-form-item label="项目名称">
          <span>{{ currentRow?.projectName || '--' }}</span>
        </el-form-item>
        <el-form-item label="开业日期">
          <el-date-picker
            v-model="openDateForm.date"
            type="date"
            placeholder="选择开业日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDateDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="openDateLoading" @click="confirmSetOpenDate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { readLevel } from '@/utility/permissions'
export default {
  name: 'Kaiye',
  data () {
    return {
      // 统计数据
      statistics: {
        pending: 0,
        completed: 0
      },

      // 是否管理员视角
      isAdminView: false,

      // 运营师列表（管理员筛选用）
      operatorList: [],

      // 查询参数
      queryInfo: {
        keyword: '',
        operatorId: '',
        status: '',
        dateArray: [],
        page: 1,
        pageSize: 20
      },

      // 列表数据
      list: [],
      total: 0,
      loading: false,

      // 设置开业时间弹窗
      openDateDialogVisible: false,
      openDateLoading: false,
      openDateForm: {
        date: ''
      },
      currentRow: null
    }
  },
  created () {
    this.checkAdminView()
    this.getList()
    this.getStatistics()
  },
  methods: {
    // 判断是否管理员视角
    checkAdminView () {
      const level = readLevel()
      const department = window.sessionStorage.getItem('department') || ''
      const job = window.sessionStorage.getItem('job') || ''
      const isAdmin = level <= 1
      const isDirector = department.match(/^运营部门/) && job === '总监'
      const isSupervisorMaster = department.match(/^运营部门-督导部/) && job === '督导主管'
      this.isAdminView = isAdmin || isDirector || isSupervisorMaster
      if (this.isAdminView) {
        this.getOperatorList()
      }
    },

    // 获取运营师列表
    async getOperatorList () {
      try {
        const { data: res } = await this.$http.get('process/getEmployeeList', {
          params: { role: 'level1Operator' }
        })
        if (res.meta.status === 200) {
          this.operatorList = res.data || []
        }
      } catch (error) {
        console.error('获取运营师列表失败:', error)
      }
    },

    // 获取统计数据
    async getStatistics () {
      try {
        const params = {}
        if (this.queryInfo.operatorId) {
          params.operatorId = this.queryInfo.operatorId
        }
        const { data: res } = await this.$http.get('process/storeOpening/statistics', { params })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.statistics = res.data
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },

    // 获取列表
    async getList () {
      this.loading = true
      try {
        const params = {
          keyword: this.queryInfo.keyword,
          operatorId: this.queryInfo.operatorId,
          status: this.queryInfo.status,
          page: this.queryInfo.page,
          pageSize: this.queryInfo.pageSize
        }
        if (this.queryInfo.dateArray && this.queryInfo.dateArray.length === 2) {
          params.startDate = this.queryInfo.dateArray[0]
          params.endDate = this.queryInfo.dateArray[1]
        }
        const { data: res } = await this.$http.get('process/storeOpening/list', { params })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list || []
        this.total = res.data.total || 0
        // 同步更新统计
        if (res.data.statistics) {
          this.statistics = res.data.statistics
        }
      } catch (error) {
        console.error('获取开业管理列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 筛选条件变化
    handleFilterChange () {
      this.queryInfo.page = 1
      this.getList()
      this.getStatistics()
    },

    // 统计卡片点击
    handleStatClick (status) {
      this.queryInfo.status = this.queryInfo.status === status ? '' : status
      this.queryInfo.page = 1
      this.getList()
    },

    // 分页
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.queryInfo.page = val
      this.getList()
    },

    // 设置开业时间
    handleSetOpenDate (row) {
      this.currentRow = row
      this.openDateForm = { date: '' }
      this.openDateDialogVisible = true
    },

    // 确认设置开业时间
    async confirmSetOpenDate () {
      if (!this.openDateForm.date) {
        return this.$message.warning('请选择开业日期')
      }

      this.openDateLoading = true
      try {
        const instanceId = this.currentRow.instanceId
        const { data: res } = await this.$http.post(`process/instances/${instanceId}/execute`, {
          nodeCode: 'STORE_OPENING',
          action: 'complete',
          data: {
            openingAt: this.openDateForm.date
          }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('设置开业时间成功')
        this.openDateDialogVisible = false
        this.getList()
        this.getStatistics()
      } catch (error) {
        console.error('设置开业时间失败:', error)
        this.$message.error('操作失败')
      } finally {
        this.openDateLoading = false
      }
    },

    // 附加信息换行处理
    getMultLine (value) {
      if (value === null || value === undefined || value === '') return '--'
      // 先转义再换行：值来自表单录入，防止 v-html 渲染注入的 HTML
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .split('\n')
        .join('<br>')
    }
  }
}
</script>

<style lang="less" scoped>
.statistics-row {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.stat-card {
  flex: 1;
  border-radius: 8px;

  /deep/ .el-card__body {
    padding: 16px 20px;
  }
}

.stat-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  .stat-label {
    font-size: 14px;
    color: #909399;
  }
}

.stat-card-body {
  text-align: center;

  .stat-value {
    font-size: 32px;
    font-weight: bold;

    &.pending { color: #e6a23c; }
    &.completed { color: #67c23a; }
  }
}

.search-bar {
  margin-bottom: 15px;
}

.el-pagination {
  margin-top: 15px;
}

.text-title {
  font-size: 14px;
  font-weight: bold;
  color: #191a1a;
}

.text-detail {
  font-size: 12px;
  color: #909399;
  line-height: 1.8;
}
</style>
